import {getStore, setStore} from '@/util/store'
import {isURL, validatenull} from '@/util/validate'
import {
	getUserInfo,
	loginByAuthCode,
	loginByMobile,
	loginBySocial,
	loginByUsername,
	logout,
	refreshToken,
} from '@/api/login'
import {deepClone, encryption} from '@/util/util'
import webiste from '@/const/website'
import {resetRouter} from '@/router/router'
import {getMenu, getTopMenu} from '@/api/admin/menu'
import {resetPassword} from '../../api/login'
import rrlog from '@meibao/traceback-record'
import {getInsureTypeListNoPage} from '@/api/product/productManage'
import {getChannelMainInfo} from '@/api/insurance/policy'
import {getMyChannelSettleInfo} from '@/api/insurance/settlement'
import {isChannel} from '@/util/channelUtil'

var sensors = require('sa-sdk-javascript')

function addPath(ele, first) {
	const menu = webiste.menu
	const propsConfig = menu.props
	const propsDefault = {
		label: propsConfig.label || 'name',
		path: propsConfig.path || 'path',
		icon: propsConfig.icon || 'icon',
		children: propsConfig.children || 'children',
	}
	const icon = ele[propsDefault.icon]
	ele[propsDefault.icon] = validatenull(icon) ? menu.iconDefault : icon
	const isChild = ele[propsDefault.children] && ele[propsDefault.children].length !== 0
	if (!isChild) {
		ele[propsDefault.children] = []
	}
	if (!isChild && first && !isURL(ele[propsDefault.path])) {
		ele[propsDefault.path] = ele[propsDefault.path] + '/index'
	} else {
		ele[propsDefault.children].forEach((child) => {
			addPath(child)
		})
	}
}

const user = {
	state: {
		userInfo:
			getStore({
				name: 'userInfo',
			}) || {},
		userInfoMain:
			getStore({
				name: 'userInfoMain',
			}) || {},
		permissions:
			getStore({
				name: 'permissions',
			}) || [],
		roles: [],
		isShowSettleHint: getStore({
			name: 'isShowSettleHint',
		}),
		menu:
			getStore({
				name: 'menu',
			}) || [],
		menuAll: [],
		expires_in:
			getStore({
				name: 'expires_in',
			}) || '',
		access_token:
			getStore({
				name: 'access_token',
			}) || '',
		access_token_helper:
			getStore({
				name: 'access_token_helper',
			}) || '',
		refresh_token:
			getStore({
				name: 'refresh_token',
			}) || '',
		//
		insureTypes:
			getStore({
				name: 'insureTypes',
			}) || [],
		//渠道控制
		difChannelType: getStore({name: 'difChannelType'}) || {},
	},
	actions: {
		// 根据用户名登录
		LoginByUsername({commit}, userInfo) {
			const user = encryption({
				data: userInfo,
				key: 'pigxpigxpigxpigx',
				param: ['password'],
			})
			commit('SET_SHOW_SETTLE_HINT', true)
			return new Promise((resolve, reject) => {
				loginByUsername(user.username, user.password, user.code, user.randomStr)
					.then((response) => {
						const data = response.data
						// 设置登录数据
						commitLoginData(commit, data, userInfo.isLocal)
						// Modified by Li Yong on 2021/09/03
						// resolve()
						var passwordStatus = data.user_info.passwordStatus
						resolve(passwordStatus)
						//
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		// 根据手机号登录
		LoginByPhone({commit}, userInfo) {
			commit('SET_SHOW_SETTLE_HINT', true)
			return new Promise((resolve, reject) => {
				loginByMobile(userInfo.mobile, userInfo.code)
					.then((response) => {
						const data = response.data
						// 设置登录数据
						commitLoginData(commit, data, userInfo.isLocal)
						resolve()
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		// 根据OpenId登录
		LoginBySocial({commit}, param) {
			return new Promise((resolve, reject) => {
				console.log('LoginBySocial-----', param)
				loginBySocial(param.state, param.code)
					.then((response = {}) => {
						const {access_token, refresh_token, expires_in, user_info = {}} = response.data
						commit('SET_ACCESS_TOKEN', access_token)
						commit('SET_REFRESH_TOKEN', refresh_token)
						commit('SET_EXPIRES_IN', expires_in)
						commit('SET_USER_INFO', user_info)
						commit('SET_RRLOG_IDENTIFY', user_info)
						let {authorities = [], originUser: {accessToken} = {}} = user_info
						commit('SET_PERMISSIONS', authorities)
						commit('CLEAR_LOCK')
						//保存助手token
						commit('SET_ACCESS_TOKEN_HELPER', accessToken)
						resolve()
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		//通过authCode登录
		loginByAuthCode({commit}, param) {
			return new Promise((resolve, reject) => {
				loginByAuthCode(param)
					.then((response) => {
						const data = response.data
						//设置登录数据
						commitLoginData(commit, data, false)
						//设置本地登录数据
						resolve()
					})
					.catch((error) => {
						reject(error)
					})
			})
		},

		// 刷新token
		RefreshToken({commit, state}) {
			return new Promise((resolve, reject) => {
				refreshToken(state.refresh_token)
					.then((response) => {
						const data = response.data
						commit('SET_ACCESS_TOKEN', data.access_token)
						commit('SET_REFRESH_TOKEN', data.refresh_token)
						commit('SET_EXPIRES_IN', data.expires_in)
						commit('CLEAR_LOCK')
						resolve()
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		// 查询用户信息
		GetUserInfo({commit}) {
			return new Promise((resolve, reject) => {
				getUserInfo()
					.then(({data: {data = {}} = {}} = {}) => {
						const {sysUser = {}, roles = [], permissions = []} = data
						commit('SET_USER_INFO', sysUser)
						commit('SET_ROLES', roles)
						commit('UPDATE_PERMISSIONS', permissions)
						// 如果不是后台管理员 则获取所属保司信息
						if (isChannel()) {
							//获取当前渠道信息
							getMyChannelSettleInfo()
								.then((res2 = {}) => {
									commit('SET_USER_INFO', {...user.state.userInfo, channelObj: res2.data.data || {}})
								})
								.finally(() => {})
						}
						resolve(data)
					})
					.catch(() => {
						reject()
					})
			})
		},
		// 查询主渠道用户信息
		GetUserInfoMain({commit}) {
			return new Promise((resolve, reject) => {
				getChannelMainInfo()
					.then((res) => {
						const data = res.data.data || {}
						commit('SET_USER_INFO_MAIN', data)
						resolve(data)
					})
					.catch(() => {
						reject()
					})
			})
		},
		//获取insureTypes
		getInsureTypes({commit}) {
			return new Promise((resolve, reject) => {
				getInsureTypeListNoPage()
					.then((res) => {
						let insureTypeLists = res.data.data
						//保存数据，加label, value
						insureTypeLists = insureTypeLists.map((item) => {
							let {name, type} = item
							return Object.assign(item, {label: name, value: `${type}`})
						})
						commit('SET_INSURE_TYPES', insureTypeLists)
						resolve()
					})
					.catch(() => {
						reject()
					})
			})
		},

		// //获取用户结算信息
		// GetSettleInfo({commit}) {
		//   return new Promise((resolve, reject) => {
		//     getMyChannelSettleInfo().then((res) => {
		//       let {settleType, settleTaxFlag = '0'} = res.data.data
		//     })
		//   })
		// },
		// 登出
		LogOut({commit}) {
			return new Promise((resolve, reject) => {
				logout()
					.then(() => {
						resetRouter()
						commit('SET_MENU', [])
						commit('SET_PERMISSIONS', [])
						commit('SET_USER_INFO', {})
						commit('SET_USER_INFO_MAIN', {})
						commit('SET_ACCESS_TOKEN', '')
						commit('SET_ACCESS_TOKEN_HELPER', '')
						commit('SET_REFRESH_TOKEN', '')
						commit('SET_EXPIRES_IN', '')
						commit('SET_ROLES', [])
						commit('DEL_ALL_TAG')
						commit('CLEAR_LOCK')
						commit('SET_SHOW_SETTLE_HINT', true)
						commit('SET_DIF_CHANNEL_TYPE', {})
						commit('SET_USER_INFO_LOCAL', {})
						resolve()
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		// 注销session
		FedLogOut({commit}) {
			return new Promise((resolve) => {
				resetRouter()
				commit('SET_MENU', [])
				commit('SET_PERMISSIONS', [])
				commit('SET_USER_INFO', {})
				commit('SET_ACCESS_TOKEN', '')
				commit('SET_REFRESH_TOKEN', '')
				commit('SET_ROLES', [])
				commit('DEL_ALL_TAG')
				commit('CLEAR_LOCK')
				commit('SET_USER_INFO_LOCAL', {})
				resolve()
			})
		},
		// 获取系统菜单
		GetMenu({commit}, obj) {
			return new Promise((resolve) => {
				getMenu(obj.id).then((res) => {
					const data = res.data.data
					if (data) {
						const menu = deepClone(data)
						menu.forEach((ele) => {
							addPath(ele)
						})
						let type = obj.type
						commit('SET_MENU', {type, menu})
						resolve(menu)
					}
				})
			})
		},
		//顶部菜单
		GetTopMenu() {
			return new Promise((resolve) => {
				getTopMenu().then((res) => {
					const data = res.data.data || []
					resolve(data)
				})
			})
		},
		// 重置密码
		ResetPassword(dataObj) {
			return new Promise((resolve, reject) => {
				resetPassword(dataObj)
					.then((response) => {
						resolve()
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		// 登录本地数据
		LoginLocalData({commit}, data = {}) {
			commitLoginData(commit, data)
		},
	},
	mutations: {
		SET_ACCESS_TOKEN: (state, access_token) => {
			state.access_token = access_token
			setStore({
				name: 'access_token',
				content: state.access_token,
				type: 'session',
			})
		},
		SET_ACCESS_TOKEN_HELPER: (state, access_token) => {
			state.access_token_helper = access_token
			setStore({
				name: 'access_token_helper',
				content: state.access_token_helper,
				type: 'session',
			})
		},
		SET_EXPIRES_IN: (state, expires_in) => {
			state.expires_in = expires_in
			setStore({
				name: 'expires_in',
				content: state.expires_in,
				type: 'session',
			})
		},
		SET_REFRESH_TOKEN: (state, rfToken) => {
			state.refresh_token = rfToken
			setStore({
				name: 'refresh_token',
				content: state.refresh_token,
				type: 'session',
			})
		},
		SET_RRLOG_IDENTIFY: (state, userInfo) => {
			if (userInfo && userInfo.id) {
				if (userInfo.userType == 'dist') {
					rrlog.identify(
						JSON.stringify({
							id: userInfo.id,
							userType: userInfo.userType,
							username: userInfo.username,
							phone: userInfo.phone,
						}),
					)
					sensors.login(userInfo.userId)
				} else {
					// 其他用户关闭回溯
					rrlog.stopRecord()
				}
			}
		},
		SET_USER_INFO: (state, userInfo) => {
			state.userInfo = userInfo
			setStore({
				name: 'userInfo',
				content: userInfo,
				type: 'session',
			})
			if (userInfo && userInfo.userType == 'dist') {
				sensors.login(userInfo.userId)
			}
		},
		SET_USER_INFO_MAIN: (state, userInfoMain) => {
			state.userInfoMain = userInfoMain
			setStore({
				name: 'userInfoMain',
				content: userInfoMain,
				type: 'session',
			})
		},
		SET_MENU: (state, params = {}) => {
			let {menu, type} = params
			if (type !== false) {
				state.menu = menu
			}
			console.log('SET_MENU', state.menu)
			setStore({
				name: 'menu',
				content: menu,
				type: 'session',
			})
		},
		SET_MENU_ALL: (state, menuAll) => {
			state.menuAll = menuAll
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
		SET_PERMISSIONS: (state, permissions) => {
			const list = {}
			for (let i = 0; i < permissions.length; i++) {
				list[permissions[i].authority] = true
			}

			state.permissions = list
			setStore({
				name: 'permissions',
				content: list,
				type: 'session',
			})
		},
		UPDATE_PERMISSIONS: (state, permissions) => {
			const list = {}
			for (let i = 0; i < permissions.length; i++) {
				list[permissions[i]] = true
			}

			state.permissions = list
			setStore({
				name: 'permissions',
				content: list,
				type: 'session',
			})
		},
		SET_SHOW_SETTLE_HINT: (state, isShowSettleHint) => {
			state.isShowSettleHint = isShowSettleHint
			setStore({
				name: 'isShowSettleHint',
				content: isShowSettleHint,
				type: 'session',
			})
		},
		SET_INSURE_TYPES: (state, insureTypes) => {
			state.insureTypes = insureTypes
			setStore({
				name: 'insureTypes',
				content: insureTypes,
				type: 'session',
			})
		},
		//渠道控制
		SET_DIF_CHANNEL_TYPE: (state, channelType) => {
			state.difChannelType = channelType
			setStore({
				name: 'difChannelType',
				content: channelType,
				type: 'session',
			})
		},
		SET_USER_INFO_LOCAL: (state, userInfo) => {
			setStore({
				name: 'userInfoLocal',
				content: userInfo,
			})
		},
	},
}
export default user

/**
 * 设置登录数据
 * @param {Object} commit
 * @param {Object} data
 * @param {Boolean} isLocal 是否本地存储
 */
export function commitLoginData(commit, data, isSaveLocal = true) {
	//解构
	const {access_token, refresh_token, expires_in, user_info = {}} = data
	const {authorities, userType = '', id = ''} = user_info
	commit('SET_ACCESS_TOKEN', access_token)
	commit('SET_REFRESH_TOKEN', refresh_token)
	commit('SET_EXPIRES_IN', expires_in)
	commit('SET_USER_INFO', user_info)
	commit('SET_RRLOG_IDENTIFY', user_info)
	commit('SET_PERMISSIONS', authorities || [])
	commit('CLEAR_LOCK')
	data.access_token_time = Date.now()
	//另外管理员的不需要！
	commit('SET_USER_INFO_LOCAL', isSaveLocal && userType === 'dist' ? data : {})
}
